module.exports = __webpack_public_path__ + "static/media/U1-T1-04A.99ba54ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T1-04A.svg
// module id = 546
// module chunks = 0